import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {SpecialAgreementsActions} from '../store';
import {SpecialAgreementsSelectors} from '../store/selectors';

@Injectable()
export class SpecialAgreementsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadSpecialAgreementsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadSpecialAgreementsDone() {

    return this.store.pipe(
      select(SpecialAgreementsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(SpecialAgreementsActions.ReadSpecialAgreements());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
